import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { Form } from "semantic-ui-react";
import { TitleCase } from "../../common";
import "../ToggleButton/button.css";

class ChangeDomain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      testServer: this.props.testServer
    };
  }

  ChangeDomain(val, e) {
    e.preventDefault();
    this.setState({ testServer: val });

    setTimeout(() => {
      this.props.onChangeDomain(val);
    }, 300);
  }

  renderButtons() {
    if (this.state.testServer !== "Test") {
      return (
        <div>
          <Button className="ui button login_active" role="button">
            Production
          </Button>{" "}
          <Button
            onClick={this.ChangeDomain.bind(this, "Test")}
            className="ui button login"
            role="button"
          >
            Test
          </Button>
        </div>
      );
    }

    return (
      <div>
        <Button
          onClick={this.ChangeDomain.bind(this, "Production")}
          className="ui button login"
          role="button"
        >
          Production
        </Button>{" "}
        <Button className="ui button login_active" role="button">
          Test
        </Button>
      </div>
    );
  }

  renderChangeDomain() {
    return (
      <div style={{ width: "100%" }} className="ui form">
        <Form.Field>
          <label
            style={{ fontWeight: "bold", color: "#578AC4", fontSize: "15px" }}
          >
            {TitleCase("Use custom domain")}
          </label>

          {this.renderButtons()}

          <br />
        </Form.Field>
      </div>
    );
  }

  render() {
    return <div>{this.renderChangeDomain()}</div>;
  }
}

ChangeDomain.propTypes = {
  storeColour: PropTypes.object,
  tablet: PropTypes.bool
};

export default ChangeDomain;



// WEBPACK FOOTER //
// ./src/components/ChangeDomain/index.js